import { render, staticRenderFns } from "./carteirasCobranca.vue?vue&type=template&id=17bcd065"
import script from "./carteirasCobranca.vue?vue&type=script&lang=js"
export * from "./carteirasCobranca.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports